import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { MiscModule } from '../Misc/misc.module';
import { CommonBasicModule } from '../Basic/basic.module';

import { FilterDropdownComponent } from './components/filterDropdown/filter-dropdown.component';
import { FilterCheckboxesComponent } from './components/filterCheckboxes/filter-checkboxes.component';
import { FilterTextComponent } from './components/filterText/filter-text.component';
import { FilterAutocompleteComponent } from './components/filterAutocomplete/filter-autocomplete.component';
import { FilterChipsComponent } from './components/filterChips/filter-chips.component';
import { FilterRangeComponent } from './components/filterRange/filter-range.component';
import { FilterDuplicatesComponent } from './components/filterDuplicates/filter-duplicates.component';
import { FilterDateQueryComponent } from './components/filterDateQuery/filter-date-query.component';
import { CustomFilterWrapperComponent } from './components/customFilterWrapper/custom-filter-wrapper.component';
import { FilterWrapperComponent } from './components/filterWrapper/filter-wrapper.component';
import { FilterGroupComponent } from './components/filterGroup/filter-group.component';
import { FilterRadioComponent } from './components/filterRadio/filter-radio.component';
import { AutoTaggingTopicsCheckboxFilterComponent } from './components/AutoTaggingTopicsCheckboxFilter/auto-tagging-topics-checkbox-filter.component';
import { MediaTypeTreeFilterComponent } from './components/MediaTypesTreeFilter/media-type-tree-filter.component';
import { FilterWidgetComponent } from './components/FilterWidget/filter-widget.component';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { FilterSingleTextComponent } from './components/filterSingleText/filter-single-text.component';
import { FilterIncludeExcludeComponent } from './components/filterIncludeExclude/filter-include-exclude.component';
import { SaveFilterDialogComponent } from './components/SaveFilterDialog/save-filter-dialog.component';
import { SavedFilterApiService } from '../../api/savedFilter/saved-filter.api.service';
import { SavedFilterService } from './services/saved-filter.service';
import { SavedFilterWrapperComponent } from './components/SavedFilterWrapper/saved-filter-wrapper.component';
import { DiscoverListsFilterComponent } from './components/DiscoverListsFilter/discover-lists-filter.component';
import { DiscoverListsFilterService } from './services/discover-lists-filter.service';

export const filterModuleImports = [
    LocalizationModule,
    CommonModule,
    FormsModule,
    CommonFormsModule,
    TooltipModule,
    RadioButtonModule,
    ToggleSwitchModule,
    AutoCompleteModule,
    MiscModule,
    CommonBasicModule,
    CoreDialogsModule,
    TakeOverModule
];

export const filterModuleDeclarations = [
    FilterDropdownComponent,
    FilterChipsComponent,
    FilterTextComponent,
    FilterSingleTextComponent,
    FilterAutocompleteComponent,
    FilterCheckboxesComponent,
    FilterRangeComponent,
    FilterDuplicatesComponent,
    FilterDateQueryComponent,
    CustomFilterWrapperComponent,
    FilterWrapperComponent,
    FilterGroupComponent,
    FilterRadioComponent,
    AutoTaggingTopicsCheckboxFilterComponent,
    MediaTypeTreeFilterComponent,
    FilterWidgetComponent,
    FilterIncludeExcludeComponent,
    SaveFilterDialogComponent,
    SavedFilterWrapperComponent,
    DiscoverListsFilterComponent
];

@NgModule({
    imports: filterModuleImports,
    declarations: filterModuleDeclarations,
    exports: [
        FilterDropdownComponent,
        FilterChipsComponent,
        AutoTaggingTopicsCheckboxFilterComponent,
        FilterWrapperComponent,
        FilterWidgetComponent,
        FilterIncludeExcludeComponent,
        SaveFilterDialogComponent,
        SavedFilterWrapperComponent,
        FilterCheckboxesComponent
    ],
    providers: [
        SavedFilterApiService,
        SavedFilterService,
        DiscoverListsFilterService
    ]
})
export class FilterModule { }
